import { createGetInjectedComponent, createGetInjectedComponentOnRender } from "@multiweb/reactCustomization";
import { FormMenuComponentProps } from "../components/FormMenuComponent/FormMenuComponentProps";
import { MenuPanelComponentProps } from "../components/MenuPanelComponent/MenuPanelComponentProps";
import { NotificationListComponentProps } from "../components/NotificationListComponent/NotificationListComponentProps";
import { QuickAccessMenuComponentProps } from "../components/QuickAccessMenuComponent/QuickAccessMenuComponentProps";
import { SubmenuListComponentProps } from "../components/SubmenuListComponent/SubmenuListComponentProps";
import { UserMenuComponentProps } from "../components/UserMenuComponent/UserMenuComponentProps";
import { defaultComponentMap } from "./registrator";
import { ReplaceableComponentNames } from "./replaceableComponentNames";

type ReplaceableComponentProps = {
    [ReplaceableComponentNames.MenuPanelComponent]: MenuPanelComponentProps;
    [ReplaceableComponentNames.SubmenuListComponent]: SubmenuListComponentProps;
    [ReplaceableComponentNames.UserMenuComponent]: UserMenuComponentProps;
    [ReplaceableComponentNames.FormMenuComponent]: FormMenuComponentProps;
    [ReplaceableComponentNames.NotificationListComponent]: NotificationListComponentProps;
    [ReplaceableComponentNames.QuickAccessMenuComponent]: QuickAccessMenuComponentProps;
};

export * from ".";

export const getInjectedComponent = createGetInjectedComponent<ReplaceableComponentProps>(defaultComponentMap);

export const getInjectedComponentOnRender = createGetInjectedComponentOnRender<ReplaceableComponentProps>(defaultComponentMap);
